export const name = 'assetsLoader' as const

export const PageResourceFetcherSymbol = Symbol('PageResourceFetcher')
export const PageResourceFetcherWithWarmupDataSymbol = Symbol('PageResourceFetcherWithWarmupData')
export const PageStyleLoaderSymbol = Symbol('PageStyleLoader')
